import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {PhotoUploadButton} from '~/ViewInvitation/routes/Landing/PhotosModule/PhotoUploadButton';
import {Typography} from '~library/atoms/Typography';

import './PhotosEmptyState.sass';

const EMPTY_STATE_IMG =
  'https://g0.evitecdn.com/invitation/designs/host-photo-module-empty-state.png';

export const PhotosEmptyState = ({
  showAddButton = false,
  isCreationFlow = false,
  emptyStateText = '',
  // biome-ignore lint/suspicious/noEmptyBlockStatements: allow empty block
  handlePost = () => {},
  collection = 'photos',
  fileUploadRef = null,
}) => {
  const isMediumAndUp = useIsMediumAndUp();

  return (
    <div className={`photos-empty-state photos-empty-state--${isCreationFlow ? 'create' : 'view'}`}>
      <img className="photos-empty-state__img" src={EMPTY_STATE_IMG} alt="empty state icon" />
      <Typography
        variant="paragraph1"
        color={isCreationFlow ? 'asphalt' : 'pebble'}
        data-qa-id="host-photos-module-empty-state-description"
      >
        {emptyStateText}
      </Typography>
      {!isCreationFlow && showAddButton && (
        <PhotoUploadButton
          largeButton={isMediumAndUp}
          collection={collection}
          handlePost={handlePost}
          fileUploadRef={fileUploadRef}
          disabled={false}
        >
          Add photos
        </PhotoUploadButton>
      )}
    </div>
  );
};
